const calendarActions = {
  CALENDAR_VIEW: 'CALENDAR_VIEW',
  CALENDAR_EVENTS: 'CALENDAR_EVENTS',
  CALENDAR_AVAILABILITY_VIEW: 'CALENDAR_AVAILABILITY_VIEW',
  changeView: (view) => ({
    type: calendarActions.CALENDAR_VIEW,
    view,
  }),
  changeEvents: (events) => ({
    type: calendarActions.CALENDAR_EVENTS,
    events,
  }),
  changeAvailabilityView: (view) => ({
    type: calendarActions.CALENDAR_AVAILABILITY_VIEW,
    availabilityView: view,
  }),
};
export default calendarActions;
